<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-list three-line>
          <template v-for="(item, index) in items">
            <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>

            <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>

            <v-list-tile v-else :key="item.title" avatar @click="alert_details(item.key)">
              <v-list-tile-avatar>
                <i class="material-icons">add_circle_outline</i>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title v-html="item.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                <v-list-tile-sub-title v-html="item.description"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <modal :serviceFilters="service_filters" :card="card" v-if="service_filters"/>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>


<script>
import modal from "../components/service_modal";

export default {
  name: "service-detail",
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  components: {
    modal
  },
  data() {
    return {
      data: this.card,
      showModal: false,
      filters: null,
      service_filters: null
    };
  },
  mounted() {
    this.$store
      .dispatch("getAllServiceFilters", {})
      .then(resp => {
        this.filters = resp;
      })
      .catch(error => {
        this.showError(error);
      });
  },
  methods: {
    format_money(value) {
      return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    create_event(key) {
      let selected_service = this.card.expanded_info[key];
      this.$router.push({
        name: "create-event",
        params: { service: selected_service }
      });
    },
    alert_details(key) {
      let selected_service = this.card.expanded_info[key];
      // default filters
      let service_filters = {
        service_info: selected_service,
        time: this.filters[0],
        location: this.filters[1],
        special_req: this.filters[2],
        num_people: this.filters[3]
      };
      switch (this.card.title) {
        case "Driving":
        case "Car Rental":
          service_filters.vehicles = this.filters[5].options.map(
            type => type.title
          );
          service_filters.round_trip = this.filters[4].options.map(
            type => type.title
          );
          break;
        case "Stay":
          service_filters.reservation_size = this.filters[6].options.map(
            el => el.title
          );
          service_filters.num_items = this.filters[7];
          service_filters.square_footage = this.filters[8];
          break;
        case "Food":
          service_filters.reservation_size = this.filters[6].options.map(
            el => el.title
          );

          service_filters.num_plates = this.filters[7];
          service_filters.food_type = this.filters[7];

          if (
            selected_service.title === "4-5 Star Restaurants - Whole Venue" ||
            selected_service.title === "4-5 Star Restaurants - Room"
          ) {
            service_filters.square_footage = this.filters[8];
          }

          break;
        case "Maid":
          if (selected_service.title === "House Keeping") {
            service_filters.reservation_size = this.filters[6].options.map(
              el => el.title
            );

            service_filters.square_footage = this.filters[8];
          }
          break;
        case "Travel":
          service_filters.round_trip = this.filters[4].options.map(
            type => type.title
          );
          break;
        case "Party":
        case "Media":
          service_filters.num_items = this.filters[7];
          service_filters.square_footage = this.filters[8];

          if (
            selected_service.title === "Bar Tending" ||
            selected_service.title === "Waiting"
          ) {
            service_filters.reservation_size = this.filters[6].options.map(
              el => el.title
            );
          }
          break;
        case "Security":
          service_filters.num_bodyguards = this.filters[7].options[0] = {
            key,
            title: "Bodyguards",
            num_bodyguards: 1
          };
          break;
        case "Couture":
        case "Personal Assistant":
          service_filters.num_items = this.filters[7];
          break;
        case "Venue Booking":
          service_filters.square_footage = this.filters[8];
          break;
      }

      if (this.showModal) {
        this.showModal = false;
      }
      this.showModal = true;

      this.$store
        .dispatch("handleModal", this.showModal)
        .then(() => {
          this.service_filters = service_filters;
        })
        .catch(error => {
          this.showError(error);
        });
      this.service_filters = service_filters;
    }
  },
  computed: {
    items() {
      let item_arr = [{ header: this.card.title + " Services" }];
      this.card.expanded_info.forEach((el, idx) => {
        let obj = {
          key: idx,
          title: el.title,
          subtitle: `<span class='text--primary'>${this.format_money(
            el.estimate
          )} USD - ${this.format_money(el.cost)} USD</span> &mdash; ${el.rate}`,
          description: el.description
        };
        item_arr.push(obj);

        if (idx < this.card.expanded_info.length - 1)
          item_arr.push({ divider: true, inset: true });
      });

      return item_arr;
    }
  }
};
</script>

<style scoped>
</style>